import React, {
  useMemo,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import Logo from "../../../../assets/images/logo.webp";
import classes from "./MainHeader.module.css";
import { UseMainHeader } from "../../../../Pregrine/Header/UseMainHeader";
import AccountTrigger from "../../../../containers/AccountTrigger/AccountTrigger";
import CartTrigger from "../../../../containers/CartTrigger/CartTrigger";
import SearchTrigger from "../../../../containers/SearchTrigger/SearchTrigger";
import SearchBar from "../../../../containers/SearchBar/searchBar";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdArrowBack,
} from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import Shimmer from "../../../../components/Shimmer";

const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;

  return function (...args) {
    const context = this;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

const MainHeader = (props) => {
  const { MegaMenuData } = props;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const widthRef = useRef(window.innerWidth);

  useEffect(() => {
    const handleResize = throttle(() => {
      const newWidth = window.innerWidth;
      if (widthRef.current !== newWidth) {
        widthRef.current = newWidth;
        setWindowWidth(newWidth);
      }
    }, 200); // Adjust the limit as needed

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const talonProps = UseMainHeader();
  const {
    handleSearchTriggerClick,
    searchTriggerRef,
    searchRef,
    isSearchOpen,
    isScrolled,
    ConfigData,
    selectedCategory,
    handleCategorySelection,
    handleBack,
    navbarMobileRef,
    isNavbarMobileOpen,
    navbarMobileTriggerRef,
    handleNavbarMobileTriggerClick,
    handleLogout,
  } = talonProps;

  const mobileNavArr = useMemo(() => {
    if (
      ConfigData &&
      ConfigData?.navigation_exclude_category &&
      MegaMenuData &&
      MegaMenuData?.category &&
      MegaMenuData?.category?.children &&
      MegaMenuData?.category?.children?.length > 0
    ) {
      const excludedCategory = MegaMenuData?.category?.children.find(
        (prod) => prod.id === Number(ConfigData?.navigation_exclude_category)
      );
      return [
        {
          name: "Products",
          children: MegaMenuData?.category?.children,
        },
        {
          name: excludedCategory?.name,
          children: excludedCategory?.children,
        },
        {
          name: "Best Seller",
          children: [],
          url_path: "/category/bestsellers",
        },
        {
          name: "Deals",
          children: [],
          url_path: "/category/deals",
        },
        {
          name: "Experience Centre",
          children: [],
          url_path: "/experience-centre",
        },
      ];
    }
    return [];
  }, [MegaMenuData, ConfigData]);

  const searchBar = useMemo(
    () => isSearchOpen && <SearchBar isOpen={isSearchOpen} ref={searchRef} />,
    [isSearchOpen, searchRef]
  );

  const handleCategorySelectionMemoized = useCallback(
    (item) => handleCategorySelection(item),
    [handleCategorySelection]
  );

  const handleLogoutMemoized = useCallback(() => {
    handleLogout();
    handleNavbarMobileTriggerClick();
  }, [handleLogout, handleNavbarMobileTriggerClick]);

  return (
    <>
      <div className="page-wrapper">
        <header className={classes.header}>
          <div
            className={`${classes.header_middle} ${classes.sticky_header} ${
              isScrolled ? classes.fixed : ""
            } `}
            data-sticky-options="{'mobile': true}"
          >
            <div className={`container ${classes.container} `}>
              <div
                className={`row d-flex align-items-center ${classes.sticky_header} `}
              >
                <div className="col-9 col-lg-2">
                  <div className={classes.header_left}>
                    <button
                      className={classes.mobile_menu_toggler}
                      onClick={handleNavbarMobileTriggerClick}
                      ref={navbarMobileTriggerRef}
                      type="button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="white"
                          d="M2 5.995c0-.55.446-.995.995-.995h8.01a.995.995 0 0 1 0 1.99h-8.01A.995.995 0 0 1 2 5.995M2 12c0-.55.446-.995.995-.995h18.01a.995.995 0 1 1 0 1.99H2.995A.995.995 0 0 1 2 12m.995 5.01a.995.995 0 0 0 0 1.99h12.01a.995.995 0 0 0 0-1.99z"
                        />
                      </svg>
                    </button>
                    <Link to="/">
                      <img
                        src={Logo}
                        className={`img-fluid ${classes.logo}`}
                        alt="Hettich_Logo"
                        width={100}
                        height={56}
                        loading="lazy"
                      />
                    </Link>
                  </div>
                </div>

                <div className="col  d-none d-lg-block">
                  {windowWidth > 992 ? (
                    <div
                      className={`${classes.header_bottom} d-none d-lg-flex`}
                      data-sticky-options="{'mobile': false}"
                    >
                      <nav className={`${classes.main_nav} w-100`}>
                        <ul className={`${classes.menu} w-100`}>
                          <li className="">
                            <span className={classes.productsNav}>
                              Products <MdKeyboardArrowDown />
                            </span>
                            <ul className={`w-100 ${classes.megamenu}`}>
                              {MegaMenuData?.category?.children?.length > 0 &&
                                MegaMenuData?.category?.children.map(
                                  (prod, idx) => {
                                    if (
                                      prod.id !=
                                      Number(
                                        ConfigData?.navigation_exclude_category
                                      )
                                    ) {
                                      return prod.name.toLowerCase() ===
                                        "other categories" ? (
                                        <li
                                          className={classes}
                                          key={prod.url_path + idx}
                                        >
                                          <Link
                                            to={"/categories"}
                                            className={classes.menu_li_a}
                                          >
                                            {prod.name}
                                          </Link>
                                        </li>
                                      ) : (
                                        <li key={prod.url_path + idx}>
                                          <Link
                                            className={classes.menu_li_a}
                                            to={`/category/${prod.url_path}`}
                                          >
                                            {prod.name}
                                            {prod.children.length > 0 ? (
                                              <MdKeyboardArrowRight
                                                size={25}
                                                className={classes.arrowWrapper}
                                              />
                                            ) : null}
                                          </Link>
                                          {prod.children.length > 0 ? (
                                            <ul className={classes.megamenu1}>
                                              {prod.children.map((sc, i) => (
                                                <li
                                                  key={sc.url_path + i}
                                                  className={
                                                    classes.megaMenuItem
                                                  }
                                                >
                                                  <Link
                                                    className={
                                                      classes.menu_li_a
                                                    }
                                                    to={`/category/${sc.url_path}`}
                                                  >
                                                    {sc.name}
                                                    {sc.children.length > 0 ? (
                                                      <MdKeyboardArrowRight
                                                        size={25}
                                                        className={
                                                          classes.arrowWrapper
                                                        }
                                                      />
                                                    ) : null}
                                                  </Link>
                                                  {sc.children.length > 0 ? (
                                                    <ul
                                                      className={`w-100 ${classes.megamenu2}`}
                                                    >
                                                      {sc.children.map(
                                                        (item, index) => (
                                                          <li
                                                            className={
                                                              classes.menu_ul_li
                                                            }
                                                            key={
                                                              item.url_path +
                                                              index
                                                            }
                                                          >
                                                            <Link
                                                              className={
                                                                classes.menu_li_a
                                                              }
                                                              to={`/category/${item.url_path}`}
                                                            >
                                                              {item.name}
                                                            </Link>
                                                          </li>
                                                        )
                                                      )}
                                                    </ul>
                                                  ) : null}
                                                </li>
                                              ))}
                                            </ul>
                                          ) : null}
                                        </li>
                                      );
                                    }
                                  }
                                )}
                            </ul>
                          </li>
                          {MegaMenuData?.category?.children.length > 0 ? (
                            MegaMenuData?.category?.children.map((prod) => {
                              if (
                                prod.id ===
                                Number(ConfigData?.navigation_exclude_category)
                              ) {
                                return (
                                  <li
                                    key={prod.url_path}
                                    className={classes.subMenu}
                                  >
                                    <Link
                                      to={`/category/${prod.url_path}`}
                                      onClick={(e) => {
                                        prod.children.length > 0 &&
                                          e.preventDefault();
                                      }}
                                    >
                                      {prod.name}
                                      {prod.children.length > 0 ? (
                                        <MdKeyboardArrowDown />
                                      ) : null}
                                    </Link>
                                    {prod.children.length > 0 ? (
                                      <ul className={classes.megamenu}>
                                        {prod.children.map((sc, i) => (
                                          <li key={sc.url_path}>
                                            <Link
                                              className={classes.menu_li_a}
                                              to={`/category/${sc.url_path}`}
                                            >
                                              {sc.name}
                                              {sc.children.length > 0 ? (
                                                <MdKeyboardArrowRight
                                                  size={25}
                                                />
                                              ) : null}
                                            </Link>
                                            {sc.children.length > 0 ? (
                                              <ul
                                                className={`w-100 ${classes.megamenu1} ${classes.excludedMenu}`}
                                              >
                                                {sc.children.map(
                                                  (item, index) => (
                                                    <li
                                                      key={
                                                        item.url_path + index
                                                      }
                                                    >
                                                      <Link
                                                        className={
                                                          classes.menu_li_a
                                                        }
                                                        to={`/category/${item.url_path}`}
                                                      >
                                                        {item.name}
                                                        {item.children.length >
                                                        0 ? (
                                                          <MdKeyboardArrowRight
                                                            size={25}
                                                          />
                                                        ) : null}
                                                      </Link>
                                                      {item.children.length >
                                                      0 ? (
                                                        <ul
                                                          className={`w-100 ${classes.megamenu2}`}
                                                        >
                                                          {item.children.map(
                                                            (
                                                              lastChild,
                                                              lid
                                                            ) => (
                                                              <li
                                                                key={
                                                                  lastChild.url_path +
                                                                  lid
                                                                }
                                                              >
                                                                <Link
                                                                  className={
                                                                    classes.menu_li_a
                                                                  }
                                                                  to={`/category/${lastChild.url_path}`}
                                                                >
                                                                  {
                                                                    lastChild.name
                                                                  }
                                                                </Link>
                                                              </li>
                                                            )
                                                          )}
                                                        </ul>
                                                      ) : null}
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            ) : null}
                                          </li>
                                        ))}
                                      </ul>
                                    ) : null}
                                  </li>
                                );
                              }
                            })
                          ) : (
                            <>
                              <Shimmer width={17.4} />
                            </>
                          )}

                          <li>
                            <Link to="/category/bestsellers">Best Seller </Link>
                          </li>

                          <li>
                            <Link to="/category/summersale">Summer Sale</Link>
                          </li>

                          <li>
                            <Link to="/experience-centre">
                              Experience Centre
                            </Link>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  ) : null}
                </div>

                <div className="col-3 col-lg-1 p-0">
                  <div className={classes.header_right}>
                    <SearchTrigger
                      onClick={handleSearchTriggerClick}
                      ref={searchTriggerRef}
                    />
                    {searchBar}
                    <div className="d-none d-md-block d-lg-block">
                      <AccountTrigger />
                    </div>
                    <div className="d-none d-md-block d-lg-block">
                      {" "}
                      <CartTrigger />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* Mobile Navbar */}
        {isNavbarMobileOpen ? (
          <div ref={navbarMobileRef} className={classes.mobile_menu_container}>
            <div className={classes.mobile_menu_wrapper}>
              {selectedCategory.length > 0 ? (
                <div className={classes.backBtnWrapper}>
                  <button
                    onClick={() => handleBack()}
                    className={classes.backBtn}
                  >
                    <MdArrowBack className={classes.backArrow} />
                    {selectedCategory[selectedCategory.length - 1]?.name}
                  </button>
                </div>
              ) : (
                <div className={classes.menuhead}>
                  <Link to="/">
                    <img
                      src={Logo}
                      className={`img-fluid ${classes.logo}`}
                      alt=""
                    />
                  </Link>
                  <span className={classes.mobile_menu_close}>
                    <RxCross2
                      size={20}
                      className={classes.clearButton}
                      onClick={handleNavbarMobileTriggerClick}
                    />
                  </span>
                </div>
              )}
              <nav className={classes.mobile_nav}>
                <ul className={classes.mobile_menu}>
                  {selectedCategory?.length === 0 && (
                    <li>
                      <Link to={`/`} onClick={handleNavbarMobileTriggerClick}>
                        Home
                      </Link>
                    </li>
                  )}
                  {MegaMenuData?.category?.children?.length > 0 &&
                    selectedCategory?.length === 0 &&
                    mobileNavArr.map((item, idx) =>
                      item?.children?.length > 0 ? (
                        <li
                          key={idx}
                          className={classes.navChildWrapper}
                          onClick={() => {
                            handleCategorySelectionMemoized(item);
                          }}
                        >
                          <span>{item.name}</span>
                          <span>
                            <MdKeyboardArrowRight size={25} />
                          </span>
                        </li>
                      ) : (
                        <li key={idx}>
                          <Link
                            to={`${item.url_path}`}
                            onClick={handleNavbarMobileTriggerClick}
                          >
                            {item.name}
                          </Link>
                        </li>
                      )
                    )}
                  {selectedCategory &&
                    selectedCategory.length > 0 &&
                    selectedCategory[selectedCategory.length - 1]?.children
                      .filter(
                        (prod) =>
                          prod.id !==
                          Number(ConfigData?.navigation_exclude_category)
                      )
                      .map((item, idx) =>
                        item.children.length > 0 ? (
                          <li key={idx} className={classes.navChildWrapper}>
                            <span className={classes.navChildCategory}>
                              {item.name !== "Other Categories" ? (
                                <Link
                                  to={`/category/${item.url_path}`}
                                  className={classes.mobileLink}
                                  onClick={handleNavbarMobileTriggerClick}
                                >
                                  {item.name}
                                </Link>
                              ) : (
                                <Link
                                  to={`/categories`}
                                  className={classes.mobileLink}
                                  onClick={handleNavbarMobileTriggerClick}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </span>
                            <button
                              onClick={() =>
                                handleCategorySelectionMemoized(item)
                              }
                            >
                              <MdKeyboardArrowRight size={25} />
                            </button>
                          </li>
                        ) : (
                          <li key={idx}>
                            <Link
                              to={`/category/${item.url_path}`}
                              onClick={handleNavbarMobileTriggerClick}
                            >
                              {item.name}
                            </Link>
                          </li>
                        )
                      )}
                </ul>
              </nav>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default MainHeader;
